import { faClock, faLock } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import styles from './RequiresRequest.module.scss'

interface RequiresRequestProps {
  isPending?: boolean
}

export const RequiresRequest = ({ isPending }: RequiresRequestProps) => {
  const { t } = useTranslation()

  return (
    <div className={`${styles.root}`}>
      {!!isPending && (
        <>
          <FontAwesomeIcon className="mr-1" size={'xs'} icon={faClock} />
          {t('components.courseCard.pendingRequest')}
        </>
      )}
      {!isPending && (
        <>
          <FontAwesomeIcon className="mr-1" size={'xs'} icon={faLock} />
          {t('components.courseCard.requiresRequest')}
        </>
      )}
    </div>
  )
}
